import { AlertState } from '@eppendorf/vnls-device-service-utils';

export function getTitleByStatus(status?: AlertState) {
  switch (status) {
    case AlertState.Alert:
      return 'Alert';
    case AlertState.Warn:
      return 'Warning';
    default:
      return 'Ok';
  }
}
